// SPEC-web-planner-008 AC-13 (manager R133) — the ONE ordering of an opportunity's
// sessions, used wherever a surface says "latest", numbers sessions or walks the
// DIA progression (the Queue, the qualification review, the Accounts list and
// details). Same single-definition shape as real-timestamp.ts and
// qualification-workload.ts: surfaces that derive "latest" twice drift apart.
//
// A FINISHED session (status Completed) is placed at the instant it was held,
// `actualStartTime`, when that is a real timestamp; every other session (live,
// scheduled, or a Completed row with no actual start) at its scheduled start.
// So a session booked for a later slot but held first sorts before sessions
// held after it (QA deal b6efb9fe, 17 Oct), while a live session keeps its
// booked place until it has finished.

import { isRealTimestamp } from './real-timestamp';

/** The session's ordering instant in epoch ms; -Infinity when undated. */
export function sessionOrderMs(m: any): number {
    const status = (m?.status ?? '').toString().toLowerCase();
    if (status === 'completed' && isRealTimestamp(m?.actualStartTime)) {
        return new Date(m.actualStartTime).getTime();
    }
    const raw = m?.startTime ?? m?.scheduledAt ?? m?.scheduledStartTime;
    const t = raw ? new Date(raw).getTime() : NaN;
    return isNaN(t) ? -Infinity : t;
}

/** Oldest first by {@link sessionOrderMs}; ties keep their incoming order. */
export function compareSessionOrder(a: any, b: any): number {
    const av = sessionOrderMs(a);
    const bv = sessionOrderMs(b);
    return av < bv ? -1 : av > bv ? 1 : 0;
}
